<template>
  <v-app class="view">

    <Menu :drawerWidth="drawer_width"></Menu>

    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>

        <form v-if="selectedObject" @submit.prevent="onSubmitObject">
          <v-card class="pa-8">
            <v-card-title>
              ตั้งค่าการคำนวน
            </v-card-title>
            <v-container>
              <v-row>
                <v-col class="col-3">
                  <v-text-field

                      v-model="selectedObject.logistic_date_ahead"
                      class="dialog-input"
                      hide-details
                      label="คำนวนล่วงหน้า"
                      outlined
                      placeholder="5"
                      required
                      suffix="วัน"
                      type="number"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_date_start_time"
                      class="dialog-input"
                      hide-details
                      label="เวลาเริ่มงาน"
                      outlined
                      placeholder="08:30"
                      required
                      suffix=""
                  >
                  </v-text-field>

                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_date_lunch_time"
                      class="dialog-input"
                      hide-details
                      label="ระยะเวลาพักเที่ยง"
                      outlined
                      placeholder=""
                      required
                      suffix="นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_date_end_time"
                      class="dialog-input"
                      hide-details
                      label="เวลาเลิกงาน"
                      outlined
                      placeholder="17:00"
                      required
                      suffix=""
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <span class="title">MT</span>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_pre_load_time_mt"
                      class="dialog-input"
                      hide-details
                      label="รอก่อนขน"
                      outlined
                      placeholder="30"
                      required
                      suffix="นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>

                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_unload_speed_mt"
                      class="dialog-input"
                      hide-details
                      label="ความเร็ว"
                      outlined
                      placeholder="10"
                      required
                      suffix="กล่อง/คน/นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_post_load_time_mt"
                      class="dialog-input"
                      hide-details
                      label="รอเสร็จ"
                      outlined
                      placeholder="30"
                      required
                      suffix="นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>

              </v-row>
              <v-row>
                <v-col>
                  <span class="title">อื่นๆ</span>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_pre_load_time_pj"
                      class="dialog-input"
                      hide-details
                      label="รอก่อนขน"
                      outlined
                      placeholder="10"
                      required
                      suffix="นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>

                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_unload_speed_pj"
                      class="dialog-input"
                      hide-details
                      label="ความเร็ว"
                      outlined
                      placeholder="10"
                      required
                      suffix="กล่อง/คน/นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field

                      v-model="selectedObject.logistic_post_load_time_pj"
                      class="dialog-input"
                      hide-details
                      label="รอเสร็จ"
                      outlined
                      placeholder="5"
                      required
                      suffix="นาที"
                      type="number"
                  >
                  </v-text-field>
                </v-col>

              </v-row>

              <v-row>



              </v-row>


            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="objectLoading"
                     color="primary" type="submit">
                บันทึก
              </v-btn>
            </v-card-actions>

          </v-card>
        </form>
      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.theme--light .primary {
  color: #FFFFFF !important;
}


</style>
<script lang="ts">

import Menu from '@/components/Logistic/Menu.vue'
import {DataArray} from '@/models/Response'
import {Truck} from '@/models/Truck'
import Helper from '@/services/Helper'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'

@Component({
  components: {LoadingDummy, Menu},
})
export default class ViewLogisticSetting extends Vue {

  search = ''

  drawer_ratio = 0.15
  drawer_width = 200

  show_password = false

  selectedObject = {
    logistic_date_start_time: '',
    logistic_date_lunch_time: '',
    logistic_date_end_time: '',
    logistic_pre_load_time_mt: '',
    logistic_unload_speed_mt: '',
    logistic_post_load_time_mt: '',
    logistic_pre_load_time_pj:'',
    logistic_unload_speed_pj:'',
    logistic_post_load_time_pj: '',
    logistic_unload_time:'',
    logistic_date_ahead: '',
  }
  objectLoading = false

  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)
    this.refreshObject().then(() => {
    })
  }

  async refreshObject() {
    const url = Helper.setting.setting.getListAPI + '?keys='+Object.keys(this.selectedObject)

    try {
      this.objectLoading = true
      this.selectedObject = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.setting)
    } catch (e) {
      alert(e)
    }
    this.objectLoading = false
  }

  async onSubmitObject() {
    const url = Helper.setting.setting.getListAPI

    try {
      this.objectLoading = true
      await Helper.post(url,{setting:this.selectedObject}).then<{ data: DataArray }>(({data}) => data.setting)
      this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})
    } catch (e) {
      alert(e)
    }
    this.objectLoading = false


  }

}
</script>
